import { isEmpty } from "lodash";
import FiltersBox from "PFApp/components/filters/filters_box";
import FiltersButton from "PFApp/components/filters/filters_button";
import FiltersPreview from "PFApp/components/filters/filters_preview";
import {
  checkFiltersAreClear,
  getValueFilters,
  handleRequestFiltersChange
} from "PFApp/use_filtered_collection";
import useStorageFilters from "PFApp/use_filtered_collection/use_storage_filters";
import { useDeterministicStringify } from "PFCore/helpers/use_deterministic_stringity";
import React, { useEffect, useState } from "react";

import css from "./filters.module.scss";

export enum FilterMode {
  Workforce = "workforce",
  Assigness = "assignees"
}

type FiltersProps = {
  // #7167 contains Meta generic type. Use it after merge
  meta: any;
  onFiltersChange: (filters: any) => void;
  isLoading: boolean;
  mode?: FilterMode;
};

const getStoragePrefix = (mode, version = 1) => `booking_module_admin_${mode}-v${version}`;

export const Filters = ({ meta, onFiltersChange, isLoading, mode = FilterMode.Workforce }: FiltersProps) => {
  const stringify = useDeterministicStringify();
  const [showFilters, setShowFilters] = useState(false);
  const storagePrefix = getStoragePrefix(mode);

  const { selectedFilters, setFilters } = useStorageFilters({
    storagePrefix,
    defaultValue: {}
  });

  useEffect(() => {
    setFilters(getValueFilters(meta?.filters || {}));
  }, [stringify(getValueFilters(meta?.filters))]);

  if (isEmpty(meta)) {
    return null;
  }

  const noFiltersSelected = isEmpty(meta.filters) || checkFiltersAreClear(meta.filters);

  const handleFilterChange = (filter, value) => {
    const newFilters = handleRequestFiltersChange(selectedFilters, filter, value);
    setFilters(newFilters);
    onFiltersChange(newFilters);
  };

  const handleFilterClear = () => {
    setFilters({});
    onFiltersChange({});
  };

  return (
    <div className={css.filters}>
      <div className={css.filtersToolbar}>
        <div className={css.filtersPreview}>
          <FiltersPreview
            meta={meta}
            blockedList={["_term"]}
            style={{ flexGrow: 1 }}
            filtersAreClear={noFiltersSelected}
            clearFilters={handleFilterClear}
            onFilterChange={handleFilterChange}
            onMoreClicked={() => setShowFilters(true)}
          />
        </div>

        <FiltersButton filtersAreClear={noFiltersSelected} onClick={() => setShowFilters((prev) => !prev)} />
      </div>

      {showFilters && (
        <div className={css.filtersBox}>
          <FiltersBox
            blockedList={[]}
            isLoading={isLoading}
            meta={meta}
            clearFilters={handleFilterClear}
            handleFilterChange={handleFilterChange}
            filtersAreClear={noFiltersSelected}
            closeFilters={() => setShowFilters(false)}
            // @ts-ignore
            clearRefValue={stringify(getValueFilters(meta?.filters))}
            allowToClose
          />
        </div>
      )}
    </div>
  );
};
